import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles/theme';

const styles = createUseStyles(
  ({ colors, modal, spacing }: ITheme) => ({
    root: {
      zIndex: 10000,

      '&[data-reach-dialog-overlay]': {
        background: modal.backdropColor,
      },
    },
    modal: {
      width: 'auto',
      padding: spacing.xxxLarge,
      margin: spacing.large,

      borderRadius: 8,

      color: colors.black,
      background: colors.background,
    },
  }),
  {
    name: 'modal',
  },
);

export default styles;
